export default __webpack_public_path__ + "static/media/AcceleronsGallery_21.8892adee.JPG";